/**
 * Webpack build for Portals starts form this file
 * It loads some 3rd party dependencies and makes them available globally
 * (to prevent need in requiring them in modules)
 * Then loads a proper main.js file in a Portal
 */

/**
 * Babel Polyfill (to include Promise etc.)
 *
 * https://babeljs.io/docs/usage/polyfill/
 */
require('babel-polyfill');

define([
    'jquery',
    'moment',
], (jquery, moment)=> {
    // jQuery has to be loaded before AngularJS
    // to make AngularJS use it instead of jqLite
    window.$ = window.jQuery = jquery;

    window.moment = moment;// needed for datetimepicker

    define([
        // Loaded using the full path because "angular" alias
        // is set to return just a global "angular" variable
        // but here we have to load an AngularJS file
        'angular-lib',
    ], ()=> {
        // AngularJS add itself to a global space automatically
        // It has to be loaded before any modules which may use it

        // START THE APP
        define([
            'portal/app',
        ], (app)=> {
            return angular.bootstrap(document, [app.name]);
        });
    });
});


// WEBPACK FOOTER //
// ../common/webpack.entry.js